interface AthletesCreatorsProps {
  image1: string;
  title1: string;
  description1: string;
  button1Text: string;
  button1Link: string;
  image2: string;
  title2: string;
  description2: string;
  button2Text: string;
  button2Link: string;
  image3: string;
  title3: string;
  description3: string;
  button3Text: string;
  button3Link: string;
}

export default function AthletesCreators({
  image1,
  title1,
  description1,
  button1Text,
  button1Link,
  image2,
  title2,
  description2,
  button2Text,
  button2Link,
  image3,
  title3,
  description3,
  button3Text,
  button3Link,
}: AthletesCreatorsProps) {
  return (
    <section className="bg-white">
      <div className="w-full md:flex">
        {/* Athletes block */}
        <div className="relative w-full aspect-square overflow-hidden">
          {/* Background image (cover) */}
          <img
            src={image1}
            alt={title1}
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Text overlay */}
          <div className="relative z-10 w-full h-full bg-[rgba(43,43,43,.35)] bg-blend-overlay flex flex-col items-center justify-center md:items-start md:justify-start p-10 text-white">
            <h1 className="text-4xl sm:text-5xl uppercase mb-4">{title1}</h1>
            <p className="mb-6">{description1}</p>
            <a
              href={button1Link}
              className="inline-block bg-white text-black uppercase px-5 py-3 rounded-lg hover:brightness-90 transition-colors font-medium"
            >
              {button1Text}
            </a>
          </div>

          <img
            alt="VenerationWear Logo"
            src="/images/logo-icon.svg"
            className="w-8 h-8 md:w-12 md:h-12 absolute right-8 bottom-8"
          />
        </div>

        {/* Creators block */}
        <div className="relative w-full aspect-square overflow-hidden">
          {/* Background image (cover) */}
          <img
            src={image2}
            alt={title2}
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Text overlay */}
          <div className="relative z-10 w-full h-full bg-[rgba(43,43,43,.35)] bg-blend-overlay flex flex-col items-center justify-center md:items-start md:justify-start p-10 text-white">
            <h1 className="text-4xl sm:text-5xl uppercase mb-4">{title2}</h1>
            <p className="mb-6">{description2}</p>
            <a
              href={button2Link}
              className="inline-block bg-white text-black uppercase px-5 py-3 rounded-lg hover:brightness-90 transition-colors font-medium"
            >
              {button2Text}
            </a>
          </div>

          <img
            alt="VenerationWear Logo"
            src="/images/logo-icon.svg"
            className="w-8 h-8 md:w-12 md:h-12 absolute right-8 bottom-8"
          />
        </div>

        {/* Businesses block */}
        <div className="relative w-full aspect-square overflow-hidden">
          {/* Background image (cover) */}
          <img
            src={image3}
            alt={title3}
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Text overlay */}
          <div className="relative z-10 w-full h-full bg-[rgba(43,43,43,.35)] bg-blend-overlay flex flex-col items-center justify-center md:items-start md:justify-start p-10 text-white">
            <h1 className="text-4xl sm:text-5xl uppercase mb-4">{title3}</h1>
            <p className="mb-6">{description3}</p>
            <a
              href={button3Link}
              className="inline-block bg-white text-black uppercase px-5 py-3 rounded-lg hover:brightness-90 transition-colors font-medium"
            >
              {button3Text}
            </a>
          </div>

          <img
            alt="VenerationWear Logo"
            src="/images/logo-icon.svg"
            className="w-8 h-8 md:w-12 md:h-12 absolute right-8 bottom-8"
          />
        </div>
      </div>
    </section>
  );
}
